import React from 'react';
import { useTranslation } from 'react-i18next';
import PrimaryBtn from '../../shared/Buttons/PrimaryButton';
import { Box } from '@mui/material';

export const QuotationNextButton = (props: {
    onClick?: () => void;
    finalSave?: boolean;
    fullWidth?: boolean;
}) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR',
    });

    return (
        <Box
            sx={{
                margin: '12px 0',
                display: 'flex',
                justifyContent: 'flex-end',
            }}
        >
            <PrimaryBtn
                type="submit"
                onClick={props.onClick}
                sx={{
                    width: props.fullWidth ? '100%' : 'fit-content',
                    '@media (max-width: 600px)': {
                        fontSize: '12px',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                    },
                }}
            >
                {!props.finalSave && t('NEXT')}
                {props.finalSave && t('SAVE')}
            </PrimaryBtn>
        </Box>
    );
};
